<template lang="pug">
#question-reports.box
  WtTile(parent :col="12")
    #loader(v-if="showSpinner")
      BLoading(
        :active.sync="showSpinner"
        :is-full-page="false"
      )
    WtTile(child :col="3" child-class="no-padding")
      BDropdown.filter-question-field(
              v-model="questionType"
              @change="updateFilteredOptions"
              )
          .sort-by-trigger(slot="trigger" slot-scope="{ active }")
            BButton(
              :label="_.find(questionTypeDropdownOptions, {value:questionType}).label"
              :icon-right="active ? 'chevron-up' : 'chevron-down'"
            )
          template(v-for="option in filterQuestionCategoryOption(questionTypeDropdownOptions)")
            BDropdownItem(
              :value="option.value") {{ option.label }} 
    WtTile(child :col="6" child-class="no-padding")
      WtMultiSelectDropDown(
        :options="filteredProgramQuestions"
        :close-on-select="false"
        :clear-on-select="false"
        :preserve-search="true"
        :placeholder="'Select question...'"
        :label="'question'"
        :track-by="'id'"
        :preselect-first="false"
        :open-direction="'bottom'"
        :hide-selected="false"
        :options-limit="300"
        @selectUnselect="handleSelectUnselect"
      )
    WtTile(child :col="3" v-if="this.questionId.length" child-class="no-padding")
      BField(:message="questionStatsReportEmailSent ? 'Email Sent' : ''")
        WtButton(
          color="primary"
          class="download-btn"
          :loading="processingDownload"
          @click.native="downloadReport"
        ).is-pulled-right DOWNLOAD

</template>

<script>
import { mapActions } from "vuex";
import WtButton from "@@/WtButton/WtButton";
import WtTitle from "@@/WtTitle/WtTitle";
import WtTile from "@@/WtTile/WtTile";
import WtMultiSelectDropDown from "@@/WtMultiSelectDropDown/WtMultiSelectDropDown";

export default {
  name: "QuestionReports",

  components: {
    WtTile,
    WtTitle,
    WtButton,
    WtMultiSelectDropDown
  },

  props: {
    programQuestions: {
      type: Array,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isCoreTier: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      question: null,
      questionId: [],
      processingDownload: false,
      questionStatsReportEmailSent: false,
      selectedQuestion: null,
      questionData: null,
      showSpinner: false,
      selectQuestionError: false,
      programId: null,
      questionType: "all"
    };
  },

  computed: {
    questionTypeDropdownOptions() {
      const questionTypes = [
        {
          value: "all",
          label: "All Questions"
        },
        {
          value: "required",
          label: "Required Questions"
        },
        {
          value: "registration",
          label: "Registration Questions"
        },
        {
          value: "scheduled",
          label: "Scheduled Questions"
        }
      ];
      const wellnessQuestionType = [
        {
          value: "wellness",
          label: "Wellness Question"
        }
      ];

      if (this.$auth.user().program.isWellnessMetricsOn) {
        return [...questionTypes, ...wellnessQuestionType];
      }

      return questionTypes;
    },

    filteredProgramQuestions() {
      if (this.questionType == "required") {
        return this.requiredQuestions();
      } else if (this.questionType == "registration") {
        return this.registrationQuestions();
      } else if (this.questionType == "wellness") {
        return this.wellnessQuestions();
      } else if (this.questionType == "scheduled") {
        return this.scheduledQuestions();
      } else {
        return this.programQuestions;
      }
    }
  },

  methods: {
    ...mapActions("challenges", ["questionReportDownload"]),
    ...mapActions(["snackBar"]),

    handleSelectUnselect(values) {
      if (!values || (values && values.length === 0)) {
        this.questionId = [];
        return;
      }
      this.showSpinner = true;
      this.questionId = values.map(el => el.id);
      this.programId = values[0].programId;
      this.question = values[0];
      this.showSpinner = false;
    },
    formatQuestionName(question) {
      let formattedName = `${question.question}`;
      return formattedName;
    },

    filterQuestionCategoryOption() {
      // We currently don't filter any options but here is an old example:
      //
      // return this.questionTypeDropdownOptions.filter(opt => {
      //   if (this.isCoreTier && opt.value == "wellness") {
      //     return false;
      //   } else {
      //     return true;
      //   }
      // });

      return this.questionTypeDropdownOptions;
    },

    requiredQuestions() {
      return this.programQuestions.filter(q => q.required);
    },
    registrationQuestions() {
      return this.programQuestions.filter(q => q.active && q.registration);
    },
    wellnessQuestions() {
      const today = new Date();
      const filteredQuestions = this.programQuestions.filter(q => {
        if (!q.isWellnessChallenge) {
          return false;
        } else {
          const startDate = new Date(q.startDate);
          return startDate <= today;
        }
      });
      return filteredQuestions;
    },
    scheduledQuestions() {
      const filteredQuestions = this.programQuestions.filter(q => {
        if ((!q.startDate && !q.endDate) || q.isWellnessChallenge) {
          return false;
        }
        return true;
      });
      return filteredQuestions;
    },
    updateFilteredOptions() {
      this.questionId = [];
    },

    downloadReport() {
      this.processingDownload = true;
      this.questionStatsReportEmailSent = false;
      this.questionReportDownload({
        questionId: this.questionId,
        programId: this.programId
      }).then(response => {
        if (
          !this._.has(response, "data") ||
          this._.has(response, "data.error.message")
        ) {
          this.snackBar({
            duration: 10000,
            type: "is-danger",
            message: this._.get(
              response,
              "error.message",
              `An error has occurred. Please try again. Or please reach out to wellness@be-engaged.co.`
            )
          });
        }
        // This is because the action, questionReportDownload, transforms to arraybuffer
        var jsonResponse = false;
        try {
          // This errors when the arraybuffer is a csv...
          jsonResponse = JSON.parse(
            new TextDecoder().decode(new Uint8Array(response.data))
          );
        } catch (e) {
          jsonResponse = false;
        }
        if (
          this._.get(jsonResponse, "data.message", false) === "sent_to_email"
        ) {
          this.snackBar({
            type: "is-info",
            message: `The report is processing and will be sent to ${
              this.$auth.user().email
            }.  Please check there in a few minutes.`
          });
          this.questionStatsReportEmailSent = true;
        } else if (this._.has(response, "data")) {
          const mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          const blob = new Blob([response.data], { type: mimeType });
          const downloadUrl = URL.createObjectURL(blob);
          const a = document.createElement("a");

          a.download = `question_user_stats_report.xlsx`;
          a.href = downloadUrl;

          document.body.appendChild(a);

          a.click();
        }

        this.processingDownload = false;
      });
    }
  }
};
</script>

<style lang="sass" scoped>
#question-reports
  .title
    margin-bottom: 0px
  small
    color: $grey
    font-size: 12px
  .is-grey
    color: $grey
  .card
    background-color: $grey-lighter
    height: 150px
  .no-padding
    padding: 0px !important
  .filter-question-field
    @media screen and (max-width: 1490px) and (min-width: 769px)
      margin-left: 4px
</style>
